import { PROPOSAL_COPY_FONT } from "@/lib/proposalTheme";

type Props = {
  proposalRef?: string | null;
  audience?: "customer" | "staff";
};

/** Fallback when D-Tools beautified layout is intended but live hierarchy cannot be rebuilt. */
export default function DtoolsLiveProposalUnavailable({
  proposalRef,
  audience = "customer",
}: Props) {
  const refLabel = String(proposalRef ?? "").trim();
  return (
    <div
      className="mx-auto max-w-2xl px-4 py-16 text-center"
      style={{ fontFamily: PROPOSAL_COPY_FONT }}
      data-testid="dtools-live-proposal-unavailable"
    >
      <h1 className="text-xl font-semibold text-[#1A2744]">Proposal preview unavailable</h1>
      <p className="mt-3 text-sm text-[#1A2744]/75">
        {audience === "staff"
          ? "This D-Tools proposal could not be rendered from saved data. Re-open the proposal in the workspace and save again, or contact support if the issue persists."
          : "This proposal is temporarily unavailable. Please contact your Clarity representative for assistance."}
      </p>
      {refLabel ? (
        <p className="mt-2 text-xs text-[#1A2744]/50" data-testid="dtools-live-proposal-unavailable-ref">
          Reference: {refLabel}
        </p>
      ) : null}
    </div>
  );
}
